/**
 * `try { fn() } catch (e) { onError(e) }` for components and hooks (lane BOO1). The React Compiler does not compile a
 * component or hook that holds a try statement with a `finally`, a `throw`, or a conditional or optional chain inside
 * it; with the try here, the component keeps a plain call and the compiler memoizes it. What a `finally` did follows
 * the call.
 */
export type Attempt<T> = { ok: true; value: T } | { ok: false }

/** Runs `fn`; a throw goes to `onError` (and on to the caller only if `onError` throws). */
export async function attempt<T>(fn: () => Promise<T>, onError: (e: unknown) => void): Promise<Attempt<T>> {
  try {
    return { ok: true, value: await fn() }
  } catch (e) {
    onError(e)
    return { ok: false }
  }
}

/** The synchronous `attempt`. */
export function attemptSync<T>(fn: () => T, onError: (e: unknown) => void): Attempt<T> {
  try {
    return { ok: true, value: fn() }
  } catch (e) {
    onError(e)
    return { ok: false }
  }
}
